import { useProductStore } from "./useProductStore";

export const useRiskModal = () =>
  useProductStore((state) => ({
    isOpen: state.riskModal,
    openModal: state.openRiskModal,
    closeModal: state.closeRiskModal,
  }));
